export const isVendorActive = (productGroup, drugManufacturer) => {
    const key = productGroup?.lowest_without_cdo;
    const drugLowest = drugManufacturer?.find((d) => (!!key ? d?.id === key[0] : false));
    return !!drugLowest?.vendor_accepted;
};

export const isVendor = (productGroup, drugManufacturer) => {
    const key = productGroup?.lowest_without_cdo;
    const drugLowest = drugManufacturer?.find((d) => (!!key ? d?.id === key[0] : false));
    return drugLowest?.type_id === 3;
};
